//src/admin/pages/AdminUserActivity.js
import React, { useEffect, useState, useContext } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { getAdminUsersActivity } from "../../services/adminUserActivity.api";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { FaUsers, FaCircle } from "react-icons/fa";
import { FaCalendarAlt, FaSearch } from "react-icons/fa";

function AdminUserActivity() {
  const { lang } = useContext(AdminLanguageContext);

  const [isOpen, setIsOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
const [searchOpen, setSearchOpen] = useState(false);


  const [dateModalOpen, setDateModalOpen] = useState(false);

const [rangeStart, setRangeStart] = useState(null);
const [rangeEnd, setRangeEnd] = useState(null);

  const [filter, setFilter] = useState("all"); // all | today | week | month | range
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [overlay, setOverlay] = useState({
  visible: false,
  user: null,
  x: 0,
  y: 0,
  position: "bottom", // 👈 add this
});

  const [hoveredUser, setHoveredUser] = useState(null);

  const [overlayHover, setOverlayHover] = useState(false);

  const [showLive, setShowLive] = useState(false);

  const [page, setPage] = useState(1);
    const perPage = 10;
    
  const isInRange = (dateStr) => {
    if (!dateStr || dateStr === "—") return false;


    const d = new Date(dateStr);
    const now = new Date();

    if (filter === "today") {
      return d.toDateString() === now.toDateString();
    }

    if (filter === "week") {
      const start = new Date();
      start.setDate(now.getDate() - 7);
      return d >= start && d <= now;
    }

    if (filter === "month") {
      return (
        d.getMonth() === now.getMonth() &&
        d.getFullYear() === now.getFullYear()
      );
    }

    if (filter === "range") {
      if (!fromDate || !toDate) return true;

      const start = new Date(fromDate);
      start.setHours(0, 0, 0, 0);

      const end = new Date(toDate);
      end.setHours(23, 59, 59, 999);

      return d >= start && d <= end;
    }

    return true;
  };

  const LIVE_MINUTES = 5;

 const isLive = (u) => {
  const last = getLatestActivity(u);
  if (!last || last === "—") return false;

  const lastDate = new Date(last);
  const now = new Date();

  const diffMinutes = (now - lastDate) / 1000 / 60;
  return diffMinutes <= LIVE_MINUTES;
};

const getLiveKey = (u) => {
  if (u.email) return `email:${u.email.toLowerCase()}`;
  if (u.phone) return `phone:${u.phone}`;
  if (u.name && u.name !== "Guest") return `name:${u.name.toLowerCase()}`;
  return `guest:${u.id}`;
};

const getLastActivityValue = (u) => {
  const last = getLatestActivity(u);

  if (!last || last === "—") return 0;
  return new Date(last).getTime();
};

const getLatestActivity = (u) => {
  const candidates = [u.lastAction, u.lastVisit].filter(
    (value) => value && value !== "—" && !isNaN(new Date(value).getTime())
  );

  if (!candidates.length) return "—";

  return candidates.sort(
    (a, b) => new Date(b).getTime() - new Date(a).getTime()
  )[0];
};

const dedupeLiveUsers = (items) => {
  const map = new Map();

  items.forEach((u) => {
    const key = getLiveKey(u);
    const existing = map.get(key);

    if (!existing) {
      map.set(key, u);
      return;
    }

    const existingLast = getLastActivityValue(existing);
    const currentLast = getLastActivityValue(u);

    if (currentLast > existingLast) {
      map.set(key, u);
    } else if (currentLast === existingLast) {
      if ((u.actions || 0) > (existing.actions || 0)) {
        map.set(key, u);
      }
    }
  });

  return Array.from(map.values());
};

  const liveUsers = dedupeLiveUsers(rows.filter(isLive));

  const filteredRows = rows.filter((u) => {
  const s = search.toLowerCase();

  const matchesSearch =
    u.name?.toLowerCase().includes(s) ||
    u.email?.toLowerCase().includes(s) ||
    u.phone?.toLowerCase().includes(s);

  return matchesSearch && isInRange(u.lastAction || u.lastVisit);
});

const totalPages = Math.ceil(filteredRows.length / perPage);
const currentPage = Math.min(page, totalPages || 1);

const paginatedRows = filteredRows.slice(
  (currentPage - 1) * perPage,
  currentPage * perPage
);

const formatDateTime = (dateStr) => {
  if (!dateStr || dateStr === "—") return "—";

  const date = new Date(dateStr);

  if (isNaN(date)) return "—";

  return date.toLocaleString(lang === "AR" ? "ar-EG" : "en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const formatTimeAgo = (dateStr) => {
  if (!dateStr || dateStr === "—") return "—";

  const date = new Date(dateStr);
  const now = new Date();

  const diffMs = now - date;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);

  if (diffMin < 1) return "Just now";
  if (diffMin === 1) return "1 min ago";
  if (diffMin < 60) return `${diffMin} mins ago`;

  if (diffHour === 1) return "1 hour ago";
  if (diffHour < 24) return `${diffHour} hours ago`;

  const diffDays = Math.floor(diffHour / 24);
  if (diffDays === 1) return "1 day ago";
  return `${diffDays} days ago`;
};

const formatSessionDuration = (start) => {
  if (!start || start === "—") return "—";

  const now = new Date();
  const startDate = new Date(start);

  const diffMs = now - startDate;
  const totalSec = Math.floor(diffMs / 1000);

  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const mins = Math.floor((totalSec % 3600) / 60);
  const secs = totalSec % 60;

  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${mins}m`;
  if (mins > 0) return `${mins}m ${secs}s`;
  return `${secs}s`;
};

const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatIdleTime = (lastActivity) => {
  if (!lastActivity || lastActivity === "—") return "—";

  const now = new Date();
  const last = new Date(lastActivity);

  const diffMs = now - last;
  const totalSec = Math.floor(diffMs / 1000);

  const mins = Math.floor(totalSec / 60);
  const secs = totalSec % 60;

  if (mins === 0) return `${secs}s`;
  return `${mins}m ${secs}s`;
};

const getActivityStatus = (u) => {
  const last = getLatestActivity(u);

  if (!last || last === "—") return "offline";

  const diff = (new Date() - new Date(last)) / 1000;

  if (diff <= 60) return "active";
  if (diff <= 300) return "idle";
  return "offline";
};

const resetDateFilter = () => {
  setFilter("all");
  setFromDate("");
  setToDate("");
  setRangeStart(null);
  setRangeEnd(null);
};

  const TEXT = {
  EN: {
    emptyTitle: "No user activity found",
emptyDesc: "User visits and actions will appear here once customers browse the store.",
    active: "Active",
  idleStatus: "Idle",
  offline: "Offline",
    title: "User Activity & Orders",
    today: "Today",
    week: "This Week",
    month: "This Month",
    reset: "Reset",
    live: "Live",
    liveCustomers: "Live Customers",
    activeLast: "Active in last",
    minutes: "minutes",
    noLive: "No users online right now",
    name: "Name",
    phone: "Phone",
    lastActivity: "Last Activity",
    email: "Email",
    orders: "Orders",
    spent: "Spent",
    visits: "Visits",
    actions: "Actions",
    lastVisit: "Last Visit",
    lastAction: "Last Action",
    loading: "Loading...",
    from: "From",
    to: "To",
    all: "All",
    session: "Session",
  idle: "Idle",
  status: "Status",

    // ✅ CORRECT PLACE
    weekDays: ["Su","Mo","Tu","We","Th","Fr","Sa"],
  },

  AR: {
      active: "نشط",
  idleStatus: "خامل",
  offline: "غير متصل",
  emptyTitle: "لا يوجد نشاط مستخدمين",
emptyDesc: "ستظهر زيارات وإجراءات المستخدمين هنا عند تصفح العملاء للمتجر.",
    title: "نشاط المستخدمين والطلبات",
    today: "اليوم",
    week: "هذا الأسبوع",
    month: "هذا الشهر",
    reset: "إعادة تعيين",
    live: "متصل الآن",
    liveCustomers: "المستخدمون المتصلون",
    activeLast: "نشط خلال آخر",
    minutes: "دقائق",
    noLive: "لا يوجد مستخدمون متصلون حالياً",
    name: "الاسم",
    phone: "الهاتف",
    lastActivity: "آخر نشاط",
    email: "البريد الإلكتروني",
    orders: "الطلبات",
    spent: "المبلغ",
    visits: "الزيارات",
    actions: "الإجراءات",
    lastVisit: "آخر زيارة",
    lastAction: "آخر إجراء",
    loading: "جاري التحميل...",
    from: "من",
    to: "إلى",
    all: "الكل",
    session: "مدة الجلسة",
  idle: "الخمول",
  status: "الحالة",

    weekDays: ["أحد","اثنين","ثلثاء","اربعاء","خميس","جمعة","سبت"],
  },
}[lang];

const UserActivityTableSkeleton = () => (
  <>
    {Array.from({ length: 8 }).map((_, i) => (
      <tr key={i} className="border-b border-[#f1f1f1] animate-pulse">
        <td className="px-4 py-3">
          <div className="h-4 w-28 bg-gray-200 rounded mx-auto" />
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-40 bg-gray-200 rounded mx-auto" />
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-8 bg-gray-200 rounded mx-auto" />
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-16 bg-gray-200 rounded mx-auto" />
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-8 bg-gray-200 rounded mx-auto" />
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-8 bg-gray-200 rounded mx-auto" />
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-28 bg-gray-200 rounded mx-auto" />
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-28 bg-gray-200 rounded mx-auto" />
        </td>
      </tr>
    ))}
  </>
);

const UserActivityMobileSkeleton = () => (
  <div className="space-y-4">
    {Array.from({ length: 4 }).map((_, i) => (
      <div
        key={i}
        className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.08)] p-4 space-y-3 animate-pulse"
      >
        <div className="h-5 w-32 bg-gray-200 rounded" />
        <div className="h-4 w-44 bg-gray-200 rounded" />

        <div className="grid grid-cols-2 gap-3 mt-3">
          <div className="h-4 w-20 bg-gray-200 rounded" />
          <div className="h-4 w-24 bg-gray-200 rounded" />
          <div className="h-4 w-20 bg-gray-200 rounded" />
          <div className="h-4 w-24 bg-gray-200 rounded" />
        </div>

        <div className="pt-3 border-t border-gray-100 space-y-2">
          <div className="h-3 w-40 bg-gray-200 rounded" />
          <div className="h-3 w-40 bg-gray-200 rounded" />
        </div>
      </div>
    ))}
  </div>
);

const EmptyActivityState = () => (
  <div className="text-center py-12 px-4">
    <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-gray-100 flex items-center justify-center">
      <FaUsers className="text-gray-400 text-xl" />
    </div>

    <h3 className="text-sm font-semibold text-gray-800">
      {TEXT.emptyTitle}
    </h3>

    <p className="text-sm text-gray-500 mt-1 max-w-[320px] mx-auto">
      {TEXT.emptyDesc}
    </p>

    {(search || filter !== "all" || fromDate || toDate) && (
      <button
        onClick={() => {
          setSearch("");
          setSearchOpen(false);
          resetDateFilter();
        }}
        className="mt-4 h-8 px-3 rounded-lg border border-gray-300 bg-white text-sm font-medium text-gray-900 hover:bg-gray-50"
      >
        {TEXT.reset}
      </button>
    )}
  </div>
);

  const CalendarRangePicker = ({ rangeStart, rangeEnd, setRangeStart, setRangeEnd }) => {
    const [currentMonth, setCurrentMonth] = useState(new Date());
  
    const startOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
    const endOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
  
    const startDay = startOfMonth.getDay();
  
    const days = [];
  
    // padding
    for (let i = 0; i < startDay; i++) {
      days.push(null);
    }
  
    for (let d = 1; d <= endOfMonth.getDate(); d++) {
      days.push(new Date(currentMonth.getFullYear(), currentMonth.getMonth(), d));
    }
  
    const isSameDay = (a, b) =>
      a && b &&
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate();
  
    const isInRange = (day) => {
      if (!rangeStart || !rangeEnd) return false;
      return day >= rangeStart && day <= rangeEnd;
    };
  
    const handleClick = (day) => {
      if (!rangeStart || (rangeStart && rangeEnd)) {
        setRangeStart(day);
        setRangeEnd(null);
      } else {
        if (day < rangeStart) {
          setRangeEnd(rangeStart);
          setRangeStart(day);
        } else {
          setRangeEnd(day);
        }
      }
    };
  

    return (
      <div>
  
        {/* HEADER */}
        <div className="flex justify-between items-center mb-3 px-2">
          <button onClick={() => setCurrentMonth(new Date(currentMonth.setMonth(currentMonth.getMonth() - 1)))}>‹</button>
  
          <div className="font-semibold text-sm">
            {currentMonth.toLocaleString(lang === "AR" ? "ar" : "en", {
                month: "long",
                year: "numeric",
              })}
          </div>
  
          <button onClick={() => setCurrentMonth(new Date(currentMonth.setMonth(currentMonth.getMonth() + 1)))}>›</button>
        </div>
  
        {/* WEEK DAYS */}
        <div className="grid grid-cols-7 text-xs text-gray-500 mb-2 px-2">
          {TEXT.weekDays.map(d => (
              <div key={d} className="text-center">{d}</div>
            ))}
        </div>
  
        {/* DAYS */}
        <div className="grid grid-cols-7 gap-1">
          {days.map((day, i) => {
            if (!day) return <div key={i} />;
  
            const selected = isSameDay(day, rangeStart) || isSameDay(day, rangeEnd);
            const inRange = isInRange(day);
  
            return (
              <button
                key={i}
                onClick={() => handleClick(day)}
                className={`
                  h-8 rounded-md text-sm
                  ${selected ? "bg-black text-white" : ""}
                  ${inRange && !selected ? "bg-gray-200" : ""}
                  hover:bg-gray-300
                `}
              >
                {day.getDate()}
              </button>
            );
          })}
        </div>
  
      </div>
    );
  };

  useEffect(() => {
  setPage(1);
}, [search]);

  useEffect(() => {
  setPage(1);
}, [filter, fromDate, toDate]);

useEffect(() => {
  let mounted = true;

  const fetchData = () => {
    getAdminUsersActivity()
      .then((data) => {
        if (mounted) setRows(data);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
  };

  fetchData(); // first load

  const interval = setInterval(fetchData, 10000); // every 10 sec

  return () => {
    mounted = false;
    clearInterval(interval);
  };
}, []);

  const isQuickFilterActive = (value) => filter === value;

  return (
    <div
      className={`flex bg-[#f1f1f1] min-h-screen ${
        isOpen ? "overflow-hidden" : ""
      }`}
    >
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div
        className={`flex-1 ${
          lang === "EN" ? "lg:ml-64" : ""
        } w-full transition-all duration-300`}
      >
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-4 sm:p-6 animate-fadeSlide">
          {/* PAGE HEADER */}
          <div className="flex items-center justify-between mb-5">
            <div className="mx-1 flex items-center gap-2">
              <div className="flex items-center justify-center w-6 h-6">
                <FaUsers className="text-gray-900 text-[18px]" />
              </div>

              <div className="flex items-baseline gap-2">
                <h1 className="text-[20px] font-semibold text-gray-900">
                  {TEXT.title}
                </h1>
              </div>
            </div>

            <button
              onClick={() => setShowLive((v) => !v)}
              className={`
                h-8 px-3
                rounded-lg
                text-sm font-medium
                transition
                flex items-center gap-2
                shadow-[0_1px_0_rgba(0,0,0,0.08),0_3px_8px_rgba(0,0,0,0.16)]
                ${
                  showLive
                    ? "bg-green-600 text-white hover:bg-green-700"
                    : "bg-[#1f1f1f] text-white hover:bg-black"
                }
              `}
            >
              {liveUsers.length > 0 ? (
  <span className="relative flex h-2 w-2">
    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
    <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
  </span>
) : (
  <span className="inline-flex h-2 w-2 rounded-full bg-gray-400"></span>
)}
              {TEXT.live}
            </button>
          </div>

          {/* LIVE USERS BOX */}
          {showLive && (
            <div className="mb-5 bg-white border border-green-200 rounded-[14px] shadow-[0_12px_32px_rgba(0,0,0,0.08),0_2px_6px_rgba(0,0,0,0.04)] overflow-hidden">
              <div className="flex items-center justify-between px-4 py-3 border-b border-green-200 bg-green-50">
                <h2 className="text-[15px] font-semibold text-green-800">
                  {TEXT.liveCustomers} ({liveUsers.length})
                </h2>

                <span className="text-sm text-green-700">
                  {TEXT.activeLast} {LIVE_MINUTES} {TEXT.minutes}
                </span>
              </div>

              <div className="p-4">
                {liveUsers.length === 0 ? (
                  <p className="text-sm text-gray-500">{TEXT.noLive}</p>
                ) : (
                  <>
                    {/* DESKTOP LIVE TABLE */}
                    <div className="hidden md:block overflow-x-auto">
                      <table className="min-w-full text-center">
                        <thead className="bg-[#f6f6f7] text-[#6d7175] text-[13px] font-medium">
                          <tr>
                            <th className="px-4 py-2">{TEXT.name}</th>
                            <th className="px-4 py-2">{TEXT.phone}</th>
                            <th className="px-4 py-2">{TEXT.actions}</th>
                            <th className="px-4 py-2">{TEXT.session}</th>
                            <th className="px-4 py-2">{TEXT.idle}</th>
                            <th className="px-4 py-2">{TEXT.status}</th>
<th className="px-4 py-2">{TEXT.lastActivity}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {liveUsers.map((u) => (
                            <tr
                              key={u.id}
                              className="border-b border-[#f1f1f1] text-[13px] hover:bg-[#f6f6f7] transition"
                            >
                              <td className="px-4 py-3 font-medium text-gray-900">
                                {u.name}
                              </td>
                              <td className="px-4 py-3 text-gray-600">
                                {u.phone || "—"}
                              </td>
                              <td
  className="px-4 py-3 text-gray-900 font-medium relative"
  onMouseEnter={(e) => {
  if (!u.lastActions || u.lastActions.length === 0) return;

  const rect = e.currentTarget.getBoundingClientRect();

  const overlayHeight = 180; // estimated height (adjust if needed)
const spaceBelow = window.innerHeight - rect.bottom;

let y;

if (spaceBelow < overlayHeight) {
  // show ABOVE
  y = rect.top - 8;
} else {
  // show BELOW
  y = rect.bottom + 8;
}

setOverlay({
  visible: true,
  user: u,
  x: rect.left + rect.width / 2,
  y,
  position: spaceBelow < overlayHeight ? "top" : "bottom",
});
}}

onMouseLeave={() => {
  setTimeout(() => {
    if (!overlayHover) {
      setOverlay((o) => ({ ...o, visible: false }));
    }
  }, 120);
}}
>
  {u.actions}
  
</td>
<td className="px-4 py-3 text-gray-600 font-medium">
  {formatSessionDuration(u.sessionStart)}
</td>
<td className="px-4 py-3 text-gray-500">
  {formatIdleTime(getLatestActivity(u))}
</td>
<td className="px-4 py-3">
  {getActivityStatus(u) === "active" && (
    <span className="text-green-600 font-medium">● {TEXT.active}</span>
  )}
  {getActivityStatus(u) === "idle" && (
    <span className="text-yellow-600 font-medium">● {TEXT.idleStatus}</span>
  )}
  {getActivityStatus(u) === "offline" && (
    <span className="text-gray-400 font-medium">● {TEXT.offline}</span>
  )}
</td>
<td className="px-4 py-3 text-green-700 font-medium">
  {formatTimeAgo(getLatestActivity(u))}
</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* MOBILE LIVE CARDS */}
                    <div className="md:hidden space-y-3">
                      {liveUsers.map((u) => (
                        <div
                          key={u.id}
                          className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.06)] p-4"
                        >
                          <div className="font-semibold text-green-700">
                            {u.name}
                          </div>

                          {u.phone && (
                            <p className="text-sm text-gray-600 mt-1">
                              📞 {u.phone}
                            </p>
                          )}

                          <p className="text-sm text-green-700 mt-1 font-semibold">
                            {formatTimeAgo(u.lastAction !== "—" ? u.lastAction : u.lastVisit)}
                          </p>
                          <p className="text-xs text-gray-500 mt-1">
  ⏱ {formatSessionDuration(u.sessionStart)}
</p>
                          <p className="text-sm text-gray-600 mt-1">
  <div
  onClick={() => setHoveredUser(hoveredUser === u.id ? null : u.id)}
  className="text-sm text-gray-600 mt-1 cursor-pointer"
>
  ⚡ {u.actions} actions
</div>

{hoveredUser === u.id && u.lastActions?.length > 0 && (
  <div className="mt-2 bg-gray-50 rounded-lg p-2 text-xs space-y-1">
    {u.lastActions.map((a, i) => (
      <div key={i}>
        <div className="font-medium">{a.type}</div>
        <div className="text-gray-400">{formatTimeAgo(a.time)}</div>
      </div>
    ))}
  </div>
)}
</p>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {/* DESKTOP TABLE */}
          <div
            className="
              hidden md:block
              bg-white
              border border-[#e3e3e3]
              rounded-[14px]
              overflow-hidden
              shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
            "
          >
            {/* TOP HEADER */}
            <div className="flex items-center justify-between px-4 py-3 border-b border-[#e3e3e3] bg-white rounded-t-[14px]">
              <div className="flex items-center gap-1 flex-wrap">
                <button
                  onClick={() => setFilter("all")}
                  className={`
                    px-3 py-[5px]
                    text-[13px] font-medium
                    rounded-md
                    transition
                    ${
                      isQuickFilterActive("all")
                        ? "bg-gray-200 text-gray-900"
                        : "text-gray-600 hover:bg-gray-200"
                    }
                  `}
                >
                  {TEXT.all}
                </button>

                <button
                  onClick={() => setFilter("today")}
                  className={`
                    px-3 py-[5px]
                    text-[13px] font-medium
                    rounded-md
                    transition
                    ${
                      isQuickFilterActive("today")
                        ? "bg-gray-200 text-gray-900"
                        : "text-gray-600 hover:bg-gray-200"
                    }
                  `}
                >
                  {TEXT.today}
                </button>

                <button
                  onClick={() => setFilter("week")}
                  className={`
                    px-3 py-[5px]
                    text-[13px] font-medium
                    rounded-md
                    transition
                    ${
                      isQuickFilterActive("week")
                        ? "bg-gray-200 text-gray-900"
                        : "text-gray-600 hover:bg-gray-200"
                    }
                  `}
                >
                  {TEXT.week}
                </button>

                <button
                  onClick={() => setFilter("month")}
                  className={`
                    px-3 py-[5px]
                    text-[13px] font-medium
                    rounded-md
                    transition
                    ${
                      isQuickFilterActive("month")
                        ? "bg-gray-200 text-gray-900"
                        : "text-gray-600 hover:bg-gray-200"
                    }
                  `}
                >
                  {TEXT.month}
                </button>
              </div>

              <div className="flex items-center gap-2 flex-wrap justify-end">
                {/* DATE BUTTON / CHIP */}
<div className="flex items-center gap-2">

{/* SEARCH MODE */}
{searchOpen ? (
  <div className="flex items-center gap-3">

    {/* SEARCH INPUT */}
    <div className="
      flex items-center justify-between
      h-9 px-3 w-[260px]
      bg-white
      border border-gray-300
      rounded-lg
      shadow-sm
      focus-within:border-gray-500
      focus-within:ring-2
      focus-within:ring-gray-200
      transition
    ">
      <div className="flex items-center gap-2 flex-1">
        <FaSearch className="text-gray-400 text-sm"/>

        <input
          autoFocus
          type="text"
          value={search}
          onChange={(e)=>setSearch(e.target.value)}
          placeholder={lang === "AR" ? "ابحث عن مستخدم..." : "Search user..."}
          className="flex-1 outline-none text-sm"
        />
      </div>

      <button
        onClick={()=>{
          setSearch("");
          setSearchOpen(false);
        }}
        className="
          w-5 h-5
          flex items-center justify-center
          rounded-full
          border border-gray-500
          text-gray-500
          hover:bg-gray-100
          transition
        "
      >
        ✕
      </button>
    </div>

    {/* CANCEL */}
    <button
      onClick={()=>{
        setSearch("");
        setSearchOpen(false);
      }}
      className="
        px-3 h-9
        bg-white
        border border-gray-300
        rounded-lg
        shadow-sm
        hover:bg-gray-50
        text-sm font-medium
      "
    >
      {lang === "AR" ? "إلغاء" : "Cancel"}
    </button>

  </div>
) : (
  <>
    {/* SEARCH BUTTON */}
    <button
      onClick={() => setSearchOpen(true)}
      className="
        flex items-center justify-center gap-1
        px-2 h-9
        bg-white
        border border-gray-300
        rounded-lg
        shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
        hover:bg-gray-50
        active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.08)]
        transition
      "
    >
      <FaSearch className="text-gray-600 text-sm" />

      <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
        <path
          d="M3 5H17M6 10H14M9 15H11"
          stroke="#4B5563"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    </button>

    {/* DATE BUTTON / CHIP */}
    {fromDate && toDate ? (
      <div className="flex items-center gap-2">
        <div className="
          flex items-center gap-2
          px-3 h-9
          bg-white
          border border-gray-300
          rounded-lg
          text-sm
          shadow-sm
        ">
          <span>
            {fromDate} → {toDate}
          </span>

          <button
            onClick={resetDateFilter}
            className="text-gray-500 hover:bg-gray-200 rounded-full w-4 h-4 flex items-center justify-center"
          >
            ✕
          </button>
        </div>
      </div>
    ) : (
      <button
        onClick={() => setDateModalOpen(true)}
        className="
          flex items-center gap-2
          h-9 px-3
          bg-[#1f1f1f]
          text-white
          rounded-lg
          text-sm font-medium
          hover:bg-black
          transition
        "
      >
        <FaCalendarAlt className="text-sm" />
        {lang === "AR" ? "تاريخ" : "Date"}
      </button>
    )}
  </>
)}
</div>
              </div>
            </div>

            <table
              dir={lang === "AR" ? "rtl" : "ltr"}
              className="w-full min-w-[820px] lg:min-w-[980px] text-center"
            >
              <thead className="bg-[#f6f6f7] text-[#6d7175] text-[13px] font-medium">
                <tr>
                  <th className="px-4 py-2">{TEXT.name}</th>
                  <th className="px-4 py-2">{TEXT.email}</th>
                  <th className="px-4 py-2">{TEXT.orders}</th>
                  <th className="px-4 py-2">{TEXT.spent}</th>
                  <th className="px-4 py-2">{TEXT.visits}</th>
                  <th className="px-4 py-2">{TEXT.actions}</th>
                  <th className="px-4 py-2">{TEXT.lastVisit}</th>
                  <th className="px-4 py-2 rounded-tr-[14px]">{TEXT.lastAction}</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
  <UserActivityTableSkeleton />
) : filteredRows.length === 0 ? (
  <tr>
    <td colSpan="8">
      <EmptyActivityState />
    </td>
  </tr>
) : (
                  paginatedRows.map((u) => (
                    <tr
  key={u.id}
  className="border-b border-[#f1f1f1] hover:bg-[#f6f6f7] transition text-[13px] cursor-pointer"
  onMouseEnter={(e) => {
    if (!u.lastActions || u.lastActions.length === 0) return;

    const rect = e.currentTarget.getBoundingClientRect();

    const overlayHeight = 180; // estimated height (adjust if needed)
const spaceBelow = window.innerHeight - rect.bottom;

let y;

if (spaceBelow < overlayHeight) {
  // show ABOVE
  y = rect.top - 8;
} else {
  // show BELOW
  y = rect.bottom + 8;
}

setOverlay({
  visible: true,
  user: u,
  x: rect.left + rect.width / 2,
  y,
  position: spaceBelow < overlayHeight ? "top" : "bottom",
});
  }}
  onMouseLeave={() => {
    setOverlay((o) => ({ ...o, visible: false }));
  }}
>
                      <td className="px-4 py-3 font-medium text-gray-900">
                        {u.name}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600">
                        {u.email || "—"}
                      </td>
                      <td className="px-4 py-3 text-center">{u.orders}</td>
                      <td className="px-4 py-3 text-center">${u.totalSpent}</td>
                      <td className="px-4 py-3 text-center">{u.visits}</td>
                     <td className="px-4 py-3 text-center text-gray-900 font-medium">
  {u.actions}
</td>
                      <td className="px-4 py-3 text-center text-gray-500">
                        {formatDateTime(u.lastVisit)}
                      </td>
                      <td className="px-4 py-3 text-center text-gray-500">
                        {formatDateTime(u.lastAction)}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
             {!loading && filteredRows.length > 0 && (
  <tfoot>
    <tr className="bg-[#f6f6f7] border-t border-[#e3e3e3]">
      <td
        colSpan="8"
        className={`px-4 py-2 ${
          lang === "EN"
            ? "rounded-br-[14px] rounded-bl-[14px]"
            : "rounded-bl-[14px] rounded-br-[14px]"
        }`}
      >
        <div
          className={`flex items-center justify-between text-sm text-gray-600 ${
            lang === "AR" ? "flex-row-reverse" : ""
          }`}
        >
          <span className="text-gray-500 text-sm">
            {filteredRows.length} {lang === "AR" ? "مستخدم" : "users"}
          </span>

          <div className="flex items-center gap-0.5">
            <button
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              className={`w-7 h-7 flex font-bold items-center justify-center rounded-md border bg-gray-200 ${
                currentPage === 1
                  ? "opacity-40 cursor-not-allowed"
                  : "hover:bg-gray-300"
              }`}
            >
              {"<"}
            </button>

            <button
              onClick={() =>
                setPage((p) => Math.min(totalPages || 1, p + 1))
              }
              disabled={currentPage === totalPages || totalPages === 0}
              className={`w-7 h-7 flex items-center font-bold justify-center rounded-md border bg-gray-200 ${
                currentPage === totalPages || totalPages === 0
                  ? "opacity-40 cursor-not-allowed"
                  : "hover:bg-gray-300"
              }`}
            >
              {">"}
            </button>

            <span className="mx-2 text-gray-600 font-bold">
              {currentPage}-{totalPages || 1}
            </span>
          </div>
        </div>
      </td>
    </tr>
  </tfoot>
)}
            </table>
          </div>

          {/* MOBILE */}
          <div className="md:hidden">
            <div className="bg-white border border-gray-200 rounded-xl p-3 mb-3 shadow-sm space-y-3">
              <div className="flex items-center gap-2 flex-wrap">
                <button
                  onClick={() => setFilter("all")}
                  className={`px-3 py-1 text-xs rounded-md transition ${
                    filter === "all"
                      ? "bg-gray-900 text-white"
                      : "bg-gray-100 text-gray-900"
                  }`}
                >
                  {TEXT.all}
                </button>

                <button
                  onClick={() => setFilter("today")}
                  className={`px-3 py-1 text-xs rounded-md transition ${
                    filter === "today"
                      ? "bg-gray-900 text-white"
                      : "bg-gray-100 text-gray-900"
                  }`}
                >
                  {TEXT.today}
                </button>

                <button
                  onClick={() => setFilter("week")}
                  className={`px-3 py-1 text-xs rounded-md transition ${
                    filter === "week"
                      ? "bg-gray-900 text-white"
                      : "bg-gray-100 text-gray-900"
                  }`}
                >
                  {TEXT.week}
                </button>

                <button
                  onClick={() => setFilter("month")}
                  className={`px-3 py-1 text-xs rounded-md transition ${
                    filter === "month"
                      ? "bg-gray-900 text-white"
                      : "bg-gray-100 text-gray-900"
                  }`}
                >
                  {TEXT.month}
                </button>
              </div>

              <div className="grid grid-cols-2 gap-2">
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                    setFilter("range");
                  }}
                  className="border rounded-lg px-3 h-10 text-sm outline-none"
                />
                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.target.value);
                    setFilter("range");
                  }}
                  className="border rounded-lg px-3 h-10 text-sm outline-none"
                />
              </div>

              <button
                onClick={() => {
                  setFilter("all");
                  setFromDate("");
                  setToDate("");
                }}
                className="w-full h-10 rounded-lg bg-gray-100 text-gray-900 text-sm font-medium"
              >
                {TEXT.reset}
              </button>
            </div>

            <div className="space-y-4">
  {loading ? (
    <UserActivityMobileSkeleton />
  ) : filteredRows.length === 0 ? (
    <div className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-sm">
      <EmptyActivityState />
    </div>
  ) : (
    paginatedRows.map((u) => (
                  <div
                    key={u.id}
                    className="bg-white border border-[#e3e3e3] rounded-[14px] shadow-[0_8px_20px_rgba(0,0,0,0.08)] p-4 space-y-3 mb-3"
                  >
                    <div className="font-semibold text-gray-900 text-base">
                      {u.name}
                    </div>

                    {u.email && (
                      <p className="text-sm text-gray-600">{u.email}</p>
                    )}

                    <div className="grid grid-cols-2 gap-3 mt-3 text-sm">
                      <div>
                        <span className="font-semibold">{TEXT.orders}:</span>{" "}
                        {u.orders}
                      </div>

                      <div>
                        <span className="font-semibold">{TEXT.spent}:</span>{" "}
                        ${u.totalSpent}
                      </div>

                      <div>
                        <span className="font-semibold">{TEXT.visits}:</span>{" "}
                        {u.visits}
                      </div>

                      <div>
                        <span className="font-semibold">{TEXT.actions}:</span>{" "}
                        {u.actions}
                      </div>
                    </div>

                    <div className="mt-3 text-xs text-gray-500 space-y-1 pt-2 border-t">
                      <div>
                        <span className="font-semibold">{TEXT.lastVisit}:</span>{" "}
                        {formatDateTime(u.lastVisit)}
                      </div>
                      <div>
                        <span className="font-semibold">{TEXT.lastAction}:</span>{" "}
                        {formatDateTime(u.lastAction)}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
            {!loading && filteredRows.length > 0 && (
  <div className="flex items-center justify-between mt-4 px-1">

    {/* COUNT */}
    <span className="text-xs text-gray-500">
      {filteredRows.length} {lang === "AR" ? "مستخدم" : "users"}
    </span>

    {/* CONTROLS */}
    <div className="flex items-center gap-1">
      <button
        onClick={() => setPage((p) => Math.max(1, p - 1))}
        disabled={currentPage === 1}
        className={`w-7 h-7 flex items-center justify-center rounded-md border bg-gray-200 ${
          currentPage === 1
            ? "opacity-40 cursor-not-allowed"
            : "active:bg-gray-300"
        }`}
      >
        {"<"}
      </button>

      <button
        onClick={() =>
          setPage((p) => Math.min(totalPages || 1, p + 1))
        }
        disabled={currentPage === totalPages || totalPages === 0}
        className={`w-7 h-7 flex items-center justify-center rounded-md border bg-gray-200 ${
          currentPage === totalPages || totalPages === 0
            ? "opacity-40 cursor-not-allowed"
            : "active:bg-gray-300"
        }`}
      >
        {">"}
      </button>

      <span className="text-xs font-semibold px-1">
        {currentPage}/{totalPages || 1}
      </span>
    </div>
  </div>
)}
          </div>
          {dateModalOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="w-[360px] bg-white border border-gray-200 rounded-[18px] shadow-[0_30px_60px_rgba(0,0,0,0.16)] overflow-hidden">

      {/* HEADER */}
      <div className="px-5 py-4 bg-[#f6f6f7] border-b border-gray-200">
        <h3 className="text-[15px] font-semibold text-gray-800">
          {lang === "AR" ? "نطاق تاريخ" : "Date range"}
        </h3>
      </div>

      {/* BODY */}
      <div className="p-4">
        <CalendarRangePicker
          rangeStart={rangeStart}
          rangeEnd={rangeEnd}
          setRangeStart={setRangeStart}
          setRangeEnd={setRangeEnd}
        />
      </div>

      {/* FOOTER */}
      <div className="px-5 py-4 bg-[#f6f6f7] border-t border-gray-200 flex justify-end gap-3">

        <button
          onClick={() => setDateModalOpen(false)}
          className="h-[36px] px-4 border rounded-lg bg-white"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={() => {
            if (!rangeStart || !rangeEnd) return;

            const from = formatLocalDate(rangeStart);
            const to = formatLocalDate(rangeEnd);

            setFromDate(from);
            setToDate(to);
            setFilter("range");

            setDateModalOpen(false);
          }}
          className="h-[36px] px-4 bg-[#202223] text-white rounded-lg"
        >
          {lang === "AR" ? "تطبيق" : "Apply"}
        </button>

      </div>
    </div>
  </div>
)}

{overlay.visible && overlay.user?.lastActions?.length > 0 && (
  <div
    className="
      fixed z-[9999]
      w-[260px]
      bg-white
      border border-gray-200
      rounded-xl
      shadow-[0_20px_40px_rgba(0,0,0,0.12)]
      p-3
    "
    style={{
  top: overlay.y,
  left: overlay.x,
  transform:
    overlay.position === "bottom"
      ? "translate(-50%, 0)"
      : "translate(-50%, -100%)",
}}
  >
    <div className="text-xs font-semibold text-gray-500 mb-2">
      {lang === "AR" ? "آخر الإجراءات" : "Last actions"}
    </div>

    <div className="space-y-2">
      {overlay.user.lastActions.map((a, i) => (
        <div key={i} className="text-xs text-gray-900">
          <div className="font-medium">{a.type}</div>

          {a.entity && (
            <div className="text-gray-500">{a.entity}</div>
          )}

          <div className="text-gray-400 text-[11px]">
            {formatTimeAgo(a.time)}
          </div>
        </div>
      ))}
    </div>
  </div>
)}

        </main>
      </div>
    </div>
  );
}

export default AdminUserActivity;